import { useParams } from 'react-router-dom';
import { useShort } from '.';
import { getVideoPlayerComponent, useVideoPlayerConfig } from '../video';
import { PLAYLIST_SEARCH_PARAM } from '../playlistContent';
// @ts-expect-error Could not find a declaration file for module
import { useSearchParam } from '../../hooks/searchParamHooks';
import { useAssetStatus } from '../userProgress';
import { useSearchParamCatalogSearch } from '../search';
export const useShortContentParams = () => {
  const {
    shortId,
    language,
    playlistNavigation
  } = useParams();
  const [[playlistIdParam]] = useSearchParam(PLAYLIST_SEARCH_PARAM);
  return {
    shortId: shortId ? Number(shortId) : undefined,
    language: language || undefined,
    playlistId: playlistIdParam ? Number(playlistIdParam) : undefined,
    playlistNavigation
  };
};
export const useShortFromPropsOrParams = ({
  shortId: shortIdProp,
  language: languageProp,
  playlistId: playlistIdProp
} = {}) => {
  const {
    shortId: shortIdParam,
    language: shortLanguageParam,
    playlistId: playlistIdParam,
    playlistNavigation
  } = useShortContentParams();
  const shortId = shortIdProp || shortIdParam;
  const language = languageProp || shortLanguageParam;
  const playlistId = playlistIdProp || playlistIdParam;
  return Object.assign({}, useShort(shortId, language, !shortId || !language), {
    shortId,
    language,
    playlistId,
    playlistNavigation
  });
};
export const useShortVideo = ({
  shortId,
  language,
  skip
}) => {
  const {
    short
  } = useShort(shortId, language, skip);
  const {
    autoPlay,
    playSpeed
  } = useVideoPlayerConfig();
  if (!short) return null;
  const {
    reference,
    referenceType,
    hubId
  } = short;
  return {
    PlayerComponent: getVideoPlayerComponent(referenceType),
    videoType: referenceType,
    videoId: reference || '',
    autoPlay,
    playSpeed,
    creatorHubId: hubId
  };
};
export const useShortStatus = (id, language) => useAssetStatus({
  id,
  type: 'SHORT_FORM_CONTENT',
  language
});
export const useShortsBannerData = skip => {
  const {
    tracksLessonsSearchQueryData: shortsBannerData,
    tracksLessonsSearchQueryLoading: shortsBannerDataLoading,
    tracksLessonsSearchQueryError: shortsBannerDataError
  } = useSearchParamCatalogSearch({
    isPartnerPage: false,
    context: 'INDIVIDUAL',
    contentTypes: ['SHORT_FORM_CONTENT'],
    status: ['NOT_STARTED'],
    skip
  });
  return {
    shortsBannerData,
    shortsBannerDataLoading,
    shortsBannerDataError
  };
};